import React, { useState } from 'react';
import './Support.css';

const ISSUE_TYPES = ['Bug', 'Feature Request', 'General Support'];
const PRIORITIES = ['Low', 'Medium', 'High', 'Critical'];
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'support@apextsgroup.com';

function buildMailtoUrl({ issueType, priority, subject, description }) {
  const subjectLine = subject.trim() || 'Support request';
  const prefix = `[${issueType}]`;
  const fullSubject = subjectLine.startsWith('[') ? subjectLine : `${prefix} ${subjectLine}`;
  const body = [
    `Issue type: ${issueType}`,
    `Priority: ${priority}`,
    '',
    description.trim() || '(No description provided)',
  ].join('\r\n');
  return `mailto:${encodeURIComponent(SUPPORT_EMAIL)}?subject=${encodeURIComponent(fullSubject)}&body=${encodeURIComponent(body)}`;
}

export default function Support() {
  const [issueType, setIssueType] = useState('Bug');
  const [priority, setPriority] = useState('Medium');
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    const subj = subject.trim();
    const desc = description.trim();
    if (!subj) {
      setError('Subject is required.');
      return;
    }
    if (!desc) {
      setError('Description is required.');
      return;
    }
    const mailtoUrl = buildMailtoUrl({
      issueType,
      priority,
      subject: subj,
      description: desc,
    });
    window.location.href = mailtoUrl;
  };

  return (
    <div className="support-page">
      <div className="support-card">
        <div className="support-header">
          <h1>Support & Bug Reports</h1>
          <p>Submit a bug report, feature request, or general support question.</p>
        </div>

        {error && (
          <div className="support-error" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="support-form">
          <div className="support-form-row">
            <div className="support-form-group">
              <label htmlFor="support-issue-type">Issue type</label>
              <select
                id="support-issue-type"
                value={issueType}
                onChange={(e) => setIssueType(e.target.value)}
                required
              >
                {ISSUE_TYPES.map((t) => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
            </div>
            <div className="support-form-group">
              <label htmlFor="support-priority">Priority</label>
              <select
                id="support-priority"
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                required
              >
                {PRIORITIES.map((p) => (
                  <option key={p} value={p}>{p}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="support-form-group">
            <label htmlFor="support-subject">Subject</label>
            <input
              id="support-subject"
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Brief summary of the issue"
              maxLength={200}
              required
            />
          </div>

          <div className="support-form-group">
            <label htmlFor="support-description">Description</label>
            <textarea
              id="support-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Describe the issue or request in detail..."
              rows={5}
              required
            />
          </div>

          <div className="support-actions">
            <button
              type="submit"
              className="support-btn support-btn-primary"
            >
              Submit request
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
